export function applyTheme(theme) {
  const darkMode = String(theme) === '1';

  document.documentElement.classList.toggle('dark-mode', darkMode);
  document.body.classList.toggle('dark-mode', darkMode);
  document.documentElement.style.colorScheme = darkMode ? 'dark' : 'light';
}
